import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

const ExperiencePage = () => {
  const { experienceId } = useParams();
  const containerRef = useRef(null);
  const [isFs, setIsFs] = useState(false);

  // Keep track of fullscreen state
  useEffect(() => {
    const onFsChange = () => {
      setIsFs(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", onFsChange);
    document.addEventListener("webkitfullscreenchange", onFsChange);
    document.addEventListener("mozfullscreenchange", onFsChange);
    document.addEventListener("MSFullscreenChange", onFsChange);
    return () => {
      document.removeEventListener("fullscreenchange", onFsChange);
      document.removeEventListener("webkitfullscreenchange", onFsChange);
      document.removeEventListener("mozfullscreenchange", onFsChange);
      document.removeEventListener("MSFullscreenChange", onFsChange);
    };
  }, []);

  const toggleFullscreen = () => {
    const el = containerRef.current;
    if (!el) return;

    if (!document.fullscreenElement) {
      if (el.requestFullscreen) el.requestFullscreen();
      else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
      else if (el.mozRequestFullScreen) el.mozRequestFullScreen();
      else if (el.msRequestFullscreen) el.msRequestFullscreen();
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.msExitFullscreen) document.msExitFullscreen();
    }
  };

  return (
    <div
      style={{
        position: "relative",
        padding: "24px",
        background: "var(--color-bg-surface, var(--color-bg-page, #f4f4f4))",
        backgroundAttachment: "fixed",
        backgroundPosition: "center top",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        ref={containerRef}
        style={{
          width: "100%",
          maxWidth: "1000px",
          aspectRatio: "5 / 3",
          minHeight: "500px",
          overflow: "hidden",
          position: "relative",
          borderRadius: "12px",
          border: "1px solid var(--color-border-subtle, rgba(0, 0, 0, 0.12))",
          background: "var(--color-bg-card, #ffffff)",
        }}
      >
        <IconButton
          onClick={toggleFullscreen}
          sx={{
            position: "absolute",
            bottom: 16,
            right: 16,
            zIndex: 10,
            bgcolor: "var(--color-bg-subtle, rgba(0, 0, 0, 0.65))",
            color: "var(--color-text-primary, #f5f7fb)",
            border: "1px solid var(--color-border-subtle, rgba(255, 255, 255, 0.18))",
            "&:hover": { bgcolor: "var(--color-bg-highlight, rgba(0, 0, 0, 0.8))" },
            width: "50px",
          }}
          aria-label={isFs ? "Exit Fullscreen" : "Enter Fullscreen"}
        >
          {isFs ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </IconButton>
        <iframe
          src={`https://viewer.10k.science/experiences/embed/${experienceId}`}
          title="10k Web Viewer"
          loading="lazy"
          allow="camera; microphone; fullscreen"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </div>
    </div>
  );
};

export default ExperiencePage;
